<template>
    <div id="circles-container">
    </div>
</template>

<script>
import "../../lib/carrotsearch.circles.js";
import { mapGetters, mapActions } from 'vuex';

export default {
    name: "circleCluster",
    mounted() {
        // this.initGraph();
    },
    computed: {
        ...mapGetters([
            'circlesData'
        ])
    },
  
    data() {
        return {
            exportGraph: null,
            circleObj: null,
            graphOptions: {
                color: [
                    '#084081',
                    '#2283ba',
                    '#67c1cb',
                    '#b4e2ba',
                    '#faecaf',
                    '#f7bb6c',
                    '#f78c55'
                ],
                legend: {
                    // type: 'scroll',
                    align: 'right',
                    right: 6,
                    itemWidth: 14,
                    itemHeight: 14
                },
                tooltip: {
                    confine: true,
                    trigger: 'axis',
                    // triggerOn: 'click',
                    axisPointer: {
                        shadowStyle: {
                            color: 'rgba(8, 130, 220, 0.1)'
                        },
                        type: 'shadow',
                        z: '0',
                    }
                },
                grid: {
                    top: '25',
                    left: '10',
                    right: '10',
                    bottom: '10',
                    containLabel: true
                },
                symbol: 'circle'
            },
            circleToolTip: ''
        };
    },
    methods: {
        updateViewportDimensions() {
        /** Set viewport size in such a way that CSS pixels correspond to physical pixels. */
            var width,
                portrait = window.orientation % 180 === 0,
                iOS = /iPad|iPhone/.test(window.navigator.userAgent),
                chrome = /Chrome/.test(window.navigator.userAgent),
                meta = document.getElementById("__viewport_meta"),
                pixelRatio;

            if (iOS) {
                width = portrait ? screen.width : screen.height;
            } else {
                pixelRatio = window.devicePixelRatio || 1;
                width = screen.width / pixelRatio;
            }

            if (!meta) {
                meta = document.createElement("meta");
                meta.id = "__viewport_meta";
                meta.name = "viewport";
                document.getElementsByTagName("head")[0].appendChild(meta);
            }

            meta.setAttribute(
                "content",
                "width=" + width + (iOS || chrome ? ", initial-scale=1" : "")
            );
        },
        getSelectedClusters() {
            var selection = this.circles.get("selection").groups,
                selectionIds = [];

            if (selection.length !== 0) {
                selection.forEach(function (value, index) {
                    selectionIds.push(value.id);
                });
            }

            return selectionIds;
        },
        onlyUnique (value, index, self) { 
            return self.indexOf(value) === index;
        },
        getDocumentsFromClusters(groups) {
            var documents = [],
                self = this;

            groups.forEach(function (value, index) {
                if (value.documents.length !== 0) {
                    documents = documents.concat(value.documents);
                }

                if (value.groups.length !== 0) {
                    documents = documents.concat(
                        self.getDocumentsFromClusters(value.groups)
                    );
                }
            });

            return documents.filter( self.onlyUnique );
        },
        buildGraph(id, exportGraph) {
            var clusterData,
                colors = this.graphOptions.color,
                color = 0,
                circles,
                self = this;

            function customAttributes(opts, params, vars) {
                if (params.level === 0) {
                if (params.index === 0 || color > colors.length - 1) {
                    color = 0;
                }

                vars.groupColor = colors[color];
                vars.labelColor = "auto";
                color++;
                }
            }

            function convertClusters(clusters) {
                return clusters.map(cluster => {
                    return {
                        label: cluster.labels.join(", "),
                        documents: cluster.ids ? cluster.ids : [],
                        groups: cluster.clusters ? convertClusters(cluster.clusters) : []
                    };
                });
            }

       

            clusterData = convertClusters(this.circlesData.clusters);

            if (CarrotSearchCircles.supported) {
                circles = new CarrotSearchCircles({
                    groupColorDecorator: customAttributes,
                    id: id,
                    captureMouseEvents: true,
                    pixelRatio: Math.max(1.5, window.devicePixelRatio || 1),
                    groupFontFamily: window.navigator.platform.match("Win")
                        ? "Helvetic, Arial, sans-serif"
                        : "Roboto, Helvetica, Arial, sans-serif",
                    groupLinePadding: -0.1,
                    zoomDecorationFillColor: "rgba(255, 255, 255, 0.2)",
                    zoomDecorationStrokeColor: "rgba(0, 0, 0, 0)",
                    groupOutlineWidth: 1,
                    groupOutlineColor: "#fff",
                    groupMinFontSize: "5",
                    groupMaxFontSize: "20",
                    expanderColor: "rgba(200, 200, 200, 0.5)",
                    expanderOutlineColor: "rgba(0, 0, 0, 0)",
                    modelChangeAnimations: "auto",
                    groupSelectionColor: "rgba(255, 128, 128, 0.1)",
                    groupSelectionOutlineColor: "rgba(255, 128, 128, 1)",
                    groupSelectionOutlineWidth: 3,
                    groupHoverColor: "rgba(0, 0, 227, 0.1)",
                    groupHoverOutlineColor: "rgba(0, 0, 227, 0.1)",
                    groupHoverOutlineWidth: 1,
                    groupHoverHierarchy: true,
                    ringScaling: 0.75,
                    angleStart: 0,
                    angleWidth: 360,
                    titleBar: "inscribed",
                    titleBarMinFontSize: 12,
                    titleBarMaxFontSize: 20,
                    // titleBarBackgroundColor: "rgba(0, 0, 0, 0)",
                    titleBarTextColor: "rgba(0, 0, 0, .7)",
                    titleBarTextPaddingLeftRight: 5,
                    titleBarTextPaddingTopBottom: 5,
                    titleBarLabelDecorator: function(attrs) {
                        if (attrs.hoverGroup) {
                            if (attrs.hoverGroup.groups.length !== 0) {
                                let data = self.getDocumentsFromClusters([attrs.hoverGroup]);
                                attrs.label = attrs.hoverGroup.label + ' (' + data.length + ')';
                            } else {
                                attrs.label = attrs.hoverGroup.label + ' (' + attrs.hoverGroup.documents.length + ')';
                            }
                        } else {
                            attrs.label = self.circleToolTip;
                        }
                    },
                    dataObject: {
                        groups: clusterData
                    },
                    rolloutTime: exportGraph ? 0 : 1,
                });

                if (!exportGraph) {
                    document.getElementById(id)
                        .addEventListener('click', () => {
                            var selection = this.circleObj.get("selection").groups,
                                applIds;

                            if (selection.length !== 0) {
                                applIds = this.getDocumentsFromClusters(selection);
                                
                                this.$parent.circlesTableData = null;
                                if (this.$parent.circlesTable) {
                                    this.$parent.circlesTable.offset = 0;
                                }
                                this.$parent.selectedApplIds = copyData(applIds.join(';'));
                                this.$parent.getCircleTableData();
								
								gtag('event', 'Click', {
									'event_category': "Circles",
									'event_label': "Select Cluster",
									'value': "Select Cluster"
								});	
				
                            } else {
                                this.$parent.selectedApplIds = null;
								gtag('event', 'Click', {
									'event_category': "Circles",
									'event_label':  "Clear Selected Cluster",
									'value':  "Clear Selected Cluster"
								});	
                            }

                            // this.resizeGraph();
                        });

                    window.addEventListener('resize', () => {
                        self.circleObj.resize();
                    });
                    window.orientationchange = function () {
                        self.circleObj.resize();
                    }
										
					gtag('event', 'Click', {
						'event_category': "Circles",
						'event_label':  "Clear Selected Cluster",
						'value':  "Clear Selected Cluster"
					});	
                }

                return circles;
            } else {
                console.error("Visualization not supported.");
            }
        },
        initGraph() {
            this.updateViewportDimensions();
            window.addEventListener(
                "orientationchange",
                this.updateViewportDimensions
            );

            this.$nextTick(() => {
                this.circleObj = this.buildGraph('circles-container');
            });
        },
        resizeGraph () {
            // var circlesDom = $(this.$el),
            //     // marginTop = parseInt(circlesDom.css('margin-top')),
            //     // marginBottom = parseInt(circlesDom.css('margin-bottom')),
            //     // margins = marginTop + marginBottom,
            //     newCirclesHeight = "";

            if (this.circleObj) {
                this.circleObj.resize();
            }
        },
        buildExportGraph() {
            var exportDiv = document.createElement("div"),
                exportDivId = "export-graph";

            exportDiv.setAttribute("id", exportDivId);
            exportDiv.style.width = "1024px";
            exportDiv.style.height = "768px";
            exportDiv.style.position = "fixed";
            exportDiv.style.top = "200%";
            exportDiv.style.opacity = "0";

            document.body.appendChild(exportDiv);

            this.exportGraph = this.buildGraph(exportDivId, true);

            this.saveGraphImage();
        },
        saveGraphImage() {
            var dataURL, downloadButton;

            dataURL = this.exportGraph.get("imageData");

            if (isIE) {
                top.consoleRef = window.open(
                "",
                "Graph Download",
                "width=1024, height=768, menubar=0, toolbar=1 , status=0, scrollbars=1, resizable=1"
                );
                top.consoleRef.document.writeln(
                "<html><head><title>Report circles.png</title></head><body bgcolor=white onLoad='self.focus()'><p>Please right click on image and select <b>Save picture as...</b> to save.</p><img src='" +
                    dataURL +
                    "'/></body></html>"
                );
                top.consoleRef.document.close();
            } else {
                downloadButton = document.createElement("a");
                downloadButton.setAttribute("id", "graph-export-button");
                downloadButton.setAttribute("download", "Report circles.png");
                downloadButton.setAttribute("href", dataURL);
                downloadButton.style.opacity = "0";
                document.body.appendChild(downloadButton);

                downloadButton.click();
                downloadButton.remove();

                document.getElementById("export-graph").remove();
            }
			
			gtag('event', 'Click', {
				'event_category': "Circles",
				'event_label':  "Export Graph PNG: circles",
				'value':  "Export Graph PNG: circles"
			});	
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
